import { init } from '@store/errorDiagnostics/actions';
import { isFetchingSelector as dimensionListIsFetchingSelector } from '@store/common/dimensionList/selectors';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import { PAGE_TYPE } from '@utils/constants';
import injectorServer from '../common/injectorServer';
import Sharing from './Sharing';
import TempDashboard from './TempDashboard';
import Dashboard from './Dashboard';

const initiators = [init, tempDashboardActions.init];

export const ErrorDiagnosticsSharing = injectorServer(
  {
    initiators,
    selector: dimensionListIsFetchingSelector,
  },
  {
    pageType: PAGE_TYPE.SHARING,
  },
)(Sharing);

export const TempDashboardErrorDiagnostics = injectorServer(
  {
    initiators,
    selector: dimensionListIsFetchingSelector,
  },
  {
    pageType: PAGE_TYPE.TEMP_DASHBOARD,
  },
)(TempDashboard);

export const DashboardErrorDiagnostics = injectorServer(
  {
    initiators,
    selector: dimensionListIsFetchingSelector,
  },
  {
    pageType: PAGE_TYPE.SAVED_DASHBOARD,
  },
)(Dashboard);
